import {Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter} from '@angular/core';
import {
  FormControl,
  Validators,
  FormGroup,
  FormBuilder,
  FormArray,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../../../environments/environment";
import { ApplicationService } from "app/services/application.service";
import { PopupService } from "../../../../services/shared/popup.service";
import { DocumenttypeService } from "app/services/documenttype.service";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { PermitService } from "app/services/permit.service";
import { VehicleService } from "app/services/vehicle.service";
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { AuthWebService } from "app/services/authweb.service";
import { DocumentsServiceService } from "app/services/documents-service.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { Account } from "app/constants/account.enum";
import { DomSanitizer } from "@angular/platform-browser";
import { PermitTypeDocumentService } from "app/services/permit-type-document.service";
import { error } from "protractor";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { isThisTypeNode } from "typescript";
import { DatePipe } from "@angular/common";
import { ScannerService } from "app/services/scanner.service";

@Component({
  selector: "app-app-uploads",
  templateUrl: "./app-uploads.component.html",
  styleUrls: ["./app-uploads.component.css"],
  providers: [PermitTypeDocumentService],
})
export class AppUploadsComponent implements OnInit {
  @Input() dataCntrl: any;

  form: FormGroup;
  model: any = [];
  tabload: boolean = false;
  listUploadRows: any = [];
  isLoading: boolean = false;
  UserDocuments: any = [];
  docTypesList: any = [];
  doctypesCodes: any = [];
  haserror: boolean = false;
  disableAdd: boolean = false;
  isViewMode: boolean = false;
  //Uploaded file data
  filebytes: string;
  filename: string;
  filetype: string;
  filesize: string;
  filedescription: string;
  img: any;
  user = { LastName: "" };
  PermitDocTypesList: any = [];
  uploadInfo: any[] = [];

  docTypeId: any;
  doctypesDesc: any;
  page = 1;

  linkedDocs: any = [];
  uploadedDocs: any = [];
  docTypeData: any = null;
  isLoadingImg: boolean = false;
  pdfSrc: any;
  isTrue: boolean = false;
  disableBtn: boolean = false;
  dtype;
  categories = [{ id: "", name: "Select Document Type", value: "" }];
  carrier_type_id: any;
  isProcess: boolean = true;
  maxMB: any;
  message: string = "Loading. Please wait...";
  dontAllowConfirm: boolean = false;

  //Vehicle specific upload
  vehicleId: any = 0;
  documentType: any = null;
  isExtra = false;
  isDuplicateMode: boolean = false;
  replaceVehicle: boolean = false;
  isAmendRoute: boolean = false;
  isCorrectionMode: boolean = false;
  isView: boolean = false;
  isPromptUserToScan = false;
  scannerMessage =
    "Please go and insert your paper to the scanner and click the scan button";
  selectedScanner: any;
  scannedDocument: any;

  //Checking if it is kiosk mode
  isKiosk: boolean = false;

  @Input("isAnnualCompliance") isAnnualCompliance: boolean = false;
  scanDocumentId: any;
  @Output() previousStep = new EventEmitter<number>();
  @Output() nextStep = new EventEmitter<number>();

  @Input() isTimeTableActive: boolean = false;
  isExternalRole: boolean = true;

  @Input() hideEdits: boolean = false;

  goBack() {

    if(!this.isTimeTableActive)
    this.previousStep.emit(5);
    else
      this.previousStep.emit(6);
  }

  goNext(){
    if(!this.isTimeTableActive)
      this.nextStep.emit(5);
    else
      this.nextStep.emit(6);
  }

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private showModal: PopupService,
    public applicationService: ApplicationService,
    private documenttypeService: DocumenttypeService,
    private router: Router,
    private permitService: PermitService,
    private vehicleService: VehicleService,
    private authWebService: AuthWebService,private toastService:ToastNotificationService,
    private documentService: DocumentsServiceService,
    private scanner: ScannerService,
    private ref: ChangeDetectorRef,
    private confirmDialogService: ConfirmDialogService,
    private utility: UtilityServiceService,
    private sanitizer: DomSanitizer,
    private activeRoute: ActivatedRoute,
    private service: PermitTypeDocumentService,
    public datepipe: DatePipe
  ) {}

  ngOnInit() {
    this.dataCntrl.uploadedDocs = [];
    this.isDuplicateMode = this.router.url.indexOf("duplicate") > 0;
    this.isCorrectionMode = this.router.url.indexOf("correction") > 0;
    this.isView = this.router.url.indexOf("isView") > 0;
    console.log("app-uploads",environment.authWebApi);
    this.maxMB = environment.authWebApi.systemData?.Configurations?.find(
      (p) => p.Code == "MaxUploadMB1"
    ).Value;
    this.dtype = environment.authWebApi.systemData?.Configurations?.find(
      (p) => p.Code == "UploadDocTypes1"
    ).Value;

    this.toastr.clear();
    if (
      this.router.url.indexOf("edit") > 0 ||
      this.router.url.indexOf("duplicate") > 0
    ) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params["id"];
        if (
          environment.authWebApi.userData.Roles.find((p) => p.Code == "ADMIN")
        ) {
          this.disableBtn = true;
        }
      });
    }
    if (this.router.url.indexOf("view") > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params["id"];
        this.isProcess = false;
        if (
          environment.authWebApi.userData.Roles.find((p) => p.Code == "ADMIN")
        ) {
          // this.disableBtn = true;
        }
      });
    }
    if (this.dataCntrl.compID) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = this.dataCntrl.appID;
        // this.isProcess = false;
        this.isAmendRoute = true;
        if (
          environment.authWebApi.userData.Roles.find((p) => p.Code == "ADMIN")
        ) {
          // this.disableBtn = true;
        }
      });
    }

    if (this.router.url.indexOf("change") > 0) {
      if (
        this.activeRoute.params["_value"].ctrlType != undefined &&
        this.activeRoute.params["_value"].ctrlType == "vehicle"
      ) {
        this.replaceVehicle = true;
      } else if (this.activeRoute.params["_value"].ctrlType == "true") {
        this.isAmendRoute = true;
      }
    }
    this.docTypeData = this.categories[0].id;

    this.populateDocTypeList();
    this.refreshDocumentList();
    this.checkIfKiosk();

    if(!this.authWebService.userData.Roles[0].IsExternalRole){
      this.isExternalRole = false;
    }
  }

  refreshDocumentList() {
    //alert(this.isAnnualCompliance);
    this.isLoading = true;
    this.documentService.getPermitById(this.dataCntrl.application.id).subscribe(
      (x: any) => {
        this.uploadedDocs = [];

        for (var i = 0; i < x.length; i++) {
          let firstNum = x[i].document_link.indexOf("#");
          //console.log(x[i].document_link.substring(firstNum + 1))
          x[i].shareId = x[i].document_link.substring(firstNum + 1);
          //console.log(x[i].document_link.substring(0, firstNum))
          //this.uploadedDocs.id = x[i].document_link.substring(firstNum + 1);
          x[i].document_link = x[i].document_link.substring(0, firstNum);

          if (this.isAnnualCompliance) {
            if (
              x[i].compliance_detail_id != null &&
              x[i].compliance_detail_id != undefined &&
              x[i].compliance_detail_id == this.dataCntrl.complianceDetail.id
            ) {
              this.uploadedDocs.push(x[i]);
              // alert(this.uploadedDocs.length);
            }
          } else {
            // if(this.replaceVehicle)
            // {
            //   if(x[i].document_type_id == 18)
            //   {
            //     this.uploadedDocs.push(x[i]);
            //   }
            // }
            // else
            if (
              x[i].compliance_detail_id == null ||
              x[i].compliance_detail_id == undefined ||
              x[i].compliance_detail_id == 0
            ) {
              this.uploadedDocs.push(x[i]);
            }
          }
        }

        this.uploadedDocs.sort((a, b) =>
          a.description > b.description ? 1 : -1
        );
        this.dataCntrl.uploadedDocs = this.uploadedDocs;
        //alert(JSON.stringify(this.uploadedDocs));

        if (this.uploadedDocs.length > 0) {
          //this.removeUploadedDocTypes();
        }
        this.UserDocuments.splice(x.filename);
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  viewDoc(id, fileName) {
    //alert(id);
    //console.log(id)
    this.isViewMode= true;
    this.isLoadingImg = true;
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    //console.log(ext);
    if (fileName.includes(".pdf")) {
      this.documentService.downloadpdf(id).subscribe((x) => {
        let objectURL = URL.createObjectURL(x);
        this.pdfSrc = objectURL;

        //alert(this.pdfSrc.toString());
        //this.pdfSrc = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //console.log(this.pdfSrc)
        this.isLoadingImg = false;
      });
      return;
    }

    this.documentService.download(id).subscribe((x) => {
      let objectURL = URL.createObjectURL(x);
      console.log(objectURL);
      this.pdfSrc = null;
      this.img = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      console.log(this.img);
      this.isLoadingImg = false;
      // this.img = x;
    });
  }
  extraDoc(doc) {
    this.linkedDocs.unshift(doc);
    this.isExtra = true;
  }
  populateDocTypeList() {
    // for this carrier get the related doc types
    //alert(JSON.stringify(this.dataCntrl.permittype));
    var permitTypetoUse = this.isAnnualCompliance
      ? this.dataCntrl.permittype.Compliance_PermitType_Id
      : this.dataCntrl.permittype.id;
    if (this.replaceVehicle == true) {
      permitTypetoUse = this.dataCntrl.permittype.id = 16; //replacement
    } else if (this.isDuplicateMode == true) {
      permitTypetoUse = this.dataCntrl.permittype.id = 32; //duplicate
    } else if (this.isCorrectionMode == true) {
      permitTypetoUse = this.dataCntrl.permittype.id = 17; //Correction
    } else if (this.isAmendRoute == true) {
      permitTypetoUse = this.dataCntrl.permittype.id = 15; //Ammend Route
    }
    //alert(permitTypetoUse);
    this.service.getLinkedAndUnlinkedDoctypes(permitTypetoUse).subscribe(
      (result: any) => {
        this.linkedDocs = result.PermitLinked;
      },
      (error) => {
        console.log(error);
      }
    );
  }
  removeUploadedDocTypes() {
    this.isLoading = true;
    if (this.uploadedDocs.length > 0) {
      let count = this.uploadedDocs.length;
      for (let knt = 0; knt < count; knt++) {
        let index = this.isDocTypeInList(
          this.uploadedDocs[knt].document_type_id
        );
        if (index != -1) {
          this.linkedDocs.splice(index, 1);
        }
      }
    }

    if (this.linkedDocs.length == 0) {
      this.utility.dontAllowConfirm = false;
    } else {
      let mandatoryDocs = this.linkedDocs.find(
        (doc) => doc.is_mandatory == true
      );
      if (
        mandatoryDocs == undefined ||
        mandatoryDocs == null ||
        this.router.url.indexOf("view") > 0
      ) {
        this.utility.dontAllowConfirm = false;
      } else {
        this.utility.dontAllowConfirm = true;
      }
    }

    this.isLoading = false;
  }
  isDocTypeInList(id: number) {
    let count = this.linkedDocs.length;
    for (let iter = 0; iter < count; iter++) {
      if (this.linkedDocs[iter].document_type_id == id) return iter;
    }
    return -1;
  }
  getDocSaved(id) {
    this.documenttypeService.getById(id).subscribe((x) => {
      //console.log(x);
      this.doctypesDesc = x;
    });
  }
  getDoctypesCodes() {
    this.documenttypeService.getAll().subscribe((x) => {
      this.doctypesCodes = x;
    });
    // this.doctypesCodes=[
    //   {
    //     "id": 1,
    //     "code": "CR",
    //     "description": "Insurance",
    //     "document_link": null,
    //     "is_template": false,
    //     "is_download": false,
    //     "group_code": "A",
    //     "sort_order": 1,
    //     "is_active": true,
    //     "display_ind": 3,
    //     "date_created": "2019-10-25T04:30:50.807",
    //     "date_modified": "2019-11-07T10:21:33.973",
    //     "user_created": "DEVUSER",
    //     "user_modified": "DEVUSER"
    //   },
    //   {
    //     "id": 2,
    //     "code": "SARS",
    //     "description": "Vehicle Licence",
    //     "document_link": null,
    //     "is_template": false,
    //     "is_download": false,
    //     "group_code": "A",
    //     "sort_order": 1,
    //     "is_active": true,
    //     "display_ind": 3,
    //     "date_created": "2019-10-25T05:57:57.493",
    //     "date_modified": "2019-11-07T10:18:49.367",
    //     "user_created": "DEVUSER",
    //     "user_modified": "DEVUSER"
    //   }
    // ]
  }

  changes() {
    this.form.statusChanges.subscribe((result) => {
      this.dataCntrl.formValid = result == "VALID" ? true : false;
    });
  }
  backtoMotivation() {
    this.applicationService.setTab(4);
    if(this.utility.timetableActive){
      document.getElementById('uploads1-stepper-prev').click();
    }else{
      document.getElementById('uploads-stepper-prev').click();
    }
  }
  addNew() {
    let object: any = {
      id: -1,
      permit_type_id: "",
      document_type_id: "",
      is_active: false,
      code: "",
      is_mandatory: false,
      description: "",
      editMode: true,
    };
    this.docTypesList.push(object);
  }
  saveUploads() {
    if (this.isAnnualCompliance && this.isView) {
      this.applicationService.setTab(2);
      return;
    }
    if (this.linkedDocs.length > 0) {
    for (let i = 0; i < this.linkedDocs.length; i++) {
      const foundItem = this.uploadedDocs.find((item) => item.description === this.linkedDocs[i].description);

      if(!foundItem && this.linkedDocs[i]?.is_mandatory){
        this.toastService.error(this.linkedDocs[i].description + ' is required','Error');
        return true;
      }
    }
  }

    for (let list of this.docTypesList) {
      if (list.code != "") {
        list.id = 0;
        list.permit_id = this.dataCntrl.permit.id;
        list.date_modified = list.date_created = new Date();
        list.user_modified = list.user_created =
          environment.authWebApi.userData.User.Username;
      }
    }
    this.haserror = false;
    this.disableAdd = false;
    this.dataCntrl.formValid = true;
    this.dataCntrl.permitTypesDocLinks = this.docTypesList;
    //console.log(this.dataCntrl.permitTypesDocLinks);
    //this.toastr.success('Saved Step 5 Successfully','Step 5');
    if (
      this.router.url.indexOf("duplicate") > 0 &&
      this.router.url.indexOf("edit") < 0
    ) {
      //this.isDuplicateMode = true;
      //console.log("duplicated");
      //console.log(this.dataCntrl.application);
      // this.applicationService.putApplicationDuplicate(this.dataCntrl.application)
      //   .subscribe(result => {
      //     this.dataCntrl.application = result;
      //     // this.saveDepatureDestination();
      //     this.toastr.success('Application duplicated successfully', 'Duplicate Application');
      //     let url: any = "carrier/permit/application/duplicate/edit/" + result.id;
      //     this.router.navigate([url]);
      //   },
      //     error => {
      //       this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
      //       // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
      //       return;
      //     });
    }
    const nextPos = this.utility.nextTabPosition(
      this.utility.sequenceNumbers.uploadsNum
    );
    //alert(this.dataCntrl.compID);
    if (this.dataCntrl.compID != null || this.dataCntrl.compID != undefined) {
      this.applicationService.setTab(2);
    } else {
      this.applicationService.setTab(nextPos);
      if(this.utility.timetableActive){
        document.getElementById('uploads1-stepper-next').click();
      }else{
        document.getElementById('uploads-stepper-next').click();
      }
    }
  }

  uploadDocument(item, index) {
    //console.log(item)
    document.getElementById("upload-" + index).click();
  }
  handleFileInput(event, id) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length > 0) {
      let file: any = null;
      const count = event.target.files.length;
      file = event.target.files[count - 1];
      let result = this.checkFileType(file.name);
      // item.document_type_id = this.docTypeData.id;
      // item.code = this.doctypesDesc.code
      // item.description=file.name;

      console.log("FileName", file.name);
      this.docTypeId = id;
      // this.uploadInfo.push(this.docTypeData);
      // localStorage.setItem('uploads',JSON.stringify(this.uploadInfo));
      const reader = new FileReader();

      if (event.target.files && event.target.files.length > 0) {
        let file: any = null;
        const count = event.target.files.length;

        file = event.target.files[count - 1];
        let result = this.checkFileType(file.name);
        console.log("FileName", file.name);

        //if File type is in not found
        if (result != -1) {
          let sizeresult = this.checkFileSize(file.size);

          if (sizeresult != -1) {
            this.ref.detectChanges();
            let isFileAlreadyUploaded = false;
            isFileAlreadyUploaded= this.handleDuplicate(file);
          console.log("isFileAlreadyUploaded",isFileAlreadyUploaded)
              console.log("user docs",this.UserDocuments);
              console.log("uploaded docs",this.uploadedDocs);

            if (isFileAlreadyUploaded) {
              return; // Exit the function if the file is already uploaded
            }

            reader.removeEventListener;
            reader.readAsDataURL(file);
            reader.onload = () => {
              this.filebytes = reader.result.toString().split(",")[1];
              (this.filename = file.name), (this.filetype = file.type);
              this.filedescription = "upload";
              this.filesize = file.size;
   
              this.validateData(this.docTypeId);
            };
          } else {
            // this.uploader.nativeElement.value = ''
            let allowedFileSize =
              environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == "MaxUploadMB1"
              );
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastService.error(
              `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
              "File Upload Failed, Please try again."
            );
          }
        } else {
          //send message allowed types
          // this.uploader.nativeElement.value = ''
          let allowedFileTypes =
            environment.authWebApi.systemData.Configurations.find(
              (p) => p.Code == "UploadDocTypes1"
            );

          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
          this.toastService.error(
            `Only these file types are allowed: PDF`,
            "File Upload Failed, Please try again."
          );
          //Only these file types are allowed  ${allowedFileTypes.Value.toString()}
        }
      }

      // this.uploader.nativeElement.value = ''
      // this.showOtherUploadsOption = false;
    }
  }
  
  fileUpload(event, item) {
    //console.log('calling----->');
    // if(item.code.code = 'undefined')
    // {
    //   return this.toastr.warning('Please select the document type first!','Upload File')
    // }
    //console.log(item)

    const reader = new FileReader();

    if (event.target.files && event.target.files.length > 0) {
      let file: any = null;
      const count = event.target.files.length;
      file = event.target.files[count - 1];
      let result = this.checkFileType(file.name);
      item.document_type_id = this.doctypesDesc.id;
      item.code = this.doctypesDesc.code;
      item.description = file.name;
      this.docTypeId = item.document_type_id;
      this.uploadInfo.push(item);
      localStorage.setItem("uploads", JSON.stringify(this.uploadInfo));
      const reader = new FileReader();

      if (event.target.files && event.target.files.length > 0) {
        let file: any = null;
        const count = event.target.files.length;

        file = event.target.files[count - 1];
        let result = this.checkFileType(file.name);

        //if File type is in not found
        if (result != -1) {
          let sizeresult = this.checkFileSize(file.size);

          if (sizeresult != -1) {
            this.ref.detectChanges();

            reader.removeEventListener;
            reader.readAsDataURL(file);
            reader.onload = () => {
              this.filebytes = reader.result.toString().split(",")[1];
              (this.filename = file.name), (this.filetype = file.type);
              this.filedescription = "upload";
              this.filesize = file.size;
              this.validateData(this.docTypeId);
            };
          } else {
            // this.uploader.nativeElement.value = ''
            let allowedFileSize =
              environment.authWebApi.systemData.Configurations.find(
                (p) => p.Code == "MaxUploadMB1"
              );
            // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
            this.toastService.error(
              `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
              "File Upload Failed, Please try again."
            );
          }
        } else {
          //send message allowed types
          // this.uploader.nativeElement.value = ''
          let allowedFileTypes =
            environment.authWebApi.systemData.Configurations.find(
              (p) => p.Code == "UploadDocTypes1"
            );

          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
          this.toastService.error(
            `Only these file types are allowed: PDF`,
            "File Upload Failed, Please try again."
          );
        }
      }

      // this.uploader.nativeElement.value = ''
      // this.showOtherUploadsOption = false;
    }
  }
  postFile(documenttypeid: any) {
    //this.dataCntrl.permit.forEach(permit => {
    let permit = this.dataCntrl.permits[0];

    const formdata = new FormData();
    formdata.append("File", this.filebytes);
    formdata.append(
      "FileName",
       this.filename
    );
    formdata.append("TypeOfFile", this.filetype);
    formdata.append("Notes", this.filedescription);
    formdata.append("FileSize", this.filesize);
    formdata.append("PermitId", permit.id);
    formdata.append(
      "PermitName",
       this.filename
    );
    formdata.append("UserLastName", this.user.LastName);
    formdata.append("documenttypeid", documenttypeid);
    formdata.append("ApplicationId", this.dataCntrl.application.id);
    if (this.dataCntrl.compID != null || this.dataCntrl.compID != undefined) {
      //alert(this.dataCntrl.complianceDetail.id);
      formdata.append("complianceDetailId", this.dataCntrl.complianceDetail.id);
    } else {
      formdata.append("complianceDetailId", "");
    }

    // vehicle specific
    if (this.vehicleId > 0 && this.documentType != null) {
      if (this.documentType.document_type_id == documenttypeid) {
        // formdata.append('ApplicationId', this.dataCntrl.application.id)
        formdata.append("VehicleId", this.vehicleId);
      } else {
        // formdata.append('ApplicationId', "0")
        formdata.append("VehicleId", "0");
      }
    } else {
      // formdata.append('ApplicationId', "0")
      formdata.append("VehicleId", "0");
    }

    this.isLoadingImg = true;
    this.isLoading = true;
    this.UserDocuments.push(this.filename);
    // this.message = 'Uploading... please wait'
    //alert(documenttypeid);
    //alert(JSON.stringify(permit));
    this.documentService
      .postPermitDocument(formdata, documenttypeid, permit.id)
      .subscribe(
        (response) => {
          this.refreshDocumentList();

          this.isLoadingImg = false;
          this.isLoading = false;
          //  this.reload()//,
          //this.dialogService.addDialog(AlertComponent, {
          //    title: 'File Uploaded',
          //    message: 'File: ' + this.filename + ' was successfully uploaded.',
          //    bold: this.filename
          //})
          //console.log(response.document_type_id)
          console.log(
            "File: " + this.filename + " was successfully uploaded.",
            "File Upload"
          );
          
        },
        (error) => {
          this.isLoadingImg = false;
          this.isLoading = false;

          //alert(JSON.stringify(error));
          // this.dialogService.addDialog(ErrorComponent, {
          //     title: 'File Upload Failed, Please try again.',
          //     message: error._body , statuscode: error.Status, url: error.Uri, servermessage: error.Message
          // }),
          this.toastService.error("File Upload Failed, Please try again.", "Error");
          // this.reload()
        }
      );

    // });
  }

  checkFileType(fileName: string) {
    // from the file name derive the extension
    let allowedFileTypes =
      environment.authWebApi.systemData.Configurations.find(
        (p) => p.Code == "UploadDocTypes1"
      );
    let fileTypesArray = allowedFileTypes.Value.toString().split(",");
    //check if file type is
    let ext = fileName.split(".")[1].toUpperCase();
    let count = fileTypesArray.length;
    for (let iter = 0; iter < count; iter++) {
      if (fileTypesArray[iter] == ext) return iter;
    }
    return -1;
  }

  checkFileSize(fileSize: number) {
    // get the maximum file size
    let allowedFileSize = environment.authWebApi.systemData.Configurations.find(
      (p) => p.Code == "MaxUploadMB1"
    );
    let maxAllowedSize = allowedFileSize.Value; //it is in MB
    let document_sizeMB = fileSize / 1000000;
    if (document_sizeMB <= maxAllowedSize) return 1;
    else return -1;
    //
  }
  validateData(documenttypeid: any) {
    if (
      this.dataCntrl.permits == null ||
      this.dataCntrl.permits == undefined ||
      this.dataCntrl.permits.length <= 0
    ) {
      // this.dialogService.addDialog(AlertComponent, { title: 'Error', message: 'Unable to upload documents ' })
      this.toastService.error(
        "Unable to upload documents! Please select permit type",
        "Error"
      );
    } else {
      this.postFile(documenttypeid);

    }
  }

  deleteDocument(item) {
    //let docs = JSON.parse(localStorage.getItem("uploads") || "[]");

    //console.log(item);
    this.isLoading = true;

    this.documentService.DeletePermitDoc(item.id).subscribe(
      (data) => {
        console.log(data);
        this.populateDocTypeList();
        this.refreshDocumentList();
        // this.documentService.getPermitById(this.dataCntrl.application.id).subscribe(x => {
        //   for (var i = 0; i < x.length; i++) {
        //     let firstNum = x[i].document_link.indexOf('#')
        //     //console.log(x[i].document_link.substring(firstNum + 1))
        //     x[i].shareId = x[i].document_link.substring(firstNum + 1);
        //     //console.log(x[i].document_link.substring(0, firstNum))
        //     this.uploadedDocs.id = x[i].document_link.substring(firstNum + 1);
        //     x[i].document_link = x[i].document_link.substring(0, firstNum);
        //     //console.log(x)
        //     //this.uploadedDocs = x;
        //     if(this.dataCntrl.compID != null || this.dataCntrl.compID != undefined)
        //   {
        //     console.log(this.uploadedDocs[i].compliance_detail_id + JSON.stringify(this.uploadedDocs[i]))
        //     if(this.uploadedDocs[i].compliance_detail_id  == null || this.uploadedDocs[i].compliance_detail_id  == undefined || this.uploadedDocs[i].compliance_detail_id == 0)
        //     {
        //       console.log("splicing");
        //        this.uploadedDocs.splice(i,1);
        //     }
        //   }
        //     //console.log(this.uploadedDocs)
        //     this.uploadedDocs.sort((a, b) => a.description > b.description ? 1 : -1)

        //   }
        //   if (this.uploadedDocs.length > 0) {
        //     this.removeUploadedDocTypes();
        //   }
        //   if (this.uploadedDocs.length > 0) {
        //     this.removeUploadedDocTypes();
        //   }
        //   this.isLoading = false;
        //   // this.populateDocTypeList();
        //   this.toastr.success('Document deleted successfully!')

        // }, error => {
        //   if (error["_body"] !== undefined && error["_body"] !== null) {
        //     this.uploadedDocs = [];

        //   }
        //   this.uploadedDocs = [];
        //   //console.log(error);

        // });
        this.isLoading = false;
      },
      (error) => {
        this.toastService.error("Error deleting document",'Error');
      }
    );
  }
  deleteDoc(doc) {
    // this.showModal.showYesNo('Delete Document', 'Are you sure you want to delete?', `You're about to delete this document`, 'Yes', 'No')
    //   .subscribe((isConfirmed) => {
    //     if (isConfirmed) {
    //       this.deleteDocument(doc)
    //     } else {
    //       return;
    //     }
    //   });
    this.confirmDialogService.confirmThis(
      "Are you sure you want to delete? You're about to delete this document",
      () => {
        this.deleteDocument(doc);
      },
      () => {
        return;
      }
    );
  }
  cancelApplication() {
    let prevUrl = localStorage.getItem("previousUrl");
    if (prevUrl.search("/permit/approval") != -1) {
      this.router.navigate(["/permit/approval/"]);
    } else if (prevUrl.search("/carrier/permit/application/mypermits") != -1) {
      this.router.navigate([
        "/carrier/permit/application/mypermits/",
        this.dataCntrl.carrierID,
      ]);
    } else {
      this.router.navigate([
        "/carrier/permit/application/",
        this.dataCntrl.carrierID,
      ]);
    }
  }
  // if (this.dataCntrl.application.id == undefined && this.dataCntrl.application.id == null) {
  // this.router.navigate(['/carrier/permit/application/' + this.dataCntrl.carrierID]);
  // } else {
  //   this.showModal.showYesNo('Delete Application', 'Are you sure you want to delete?', `You're about to delete application`, 'Yes', 'No')
  //     .subscribe((isConfirmed) => {
  //       if (isConfirmed) {
  //         this.deleteApplication()
  //       } else {
  //         return;
  //       }
  //     });
  // }
  // }
  deleteApplication() {
    //console.log("delete application");

    this.permitService.deletePermit(this.dataCntrl.permit.id).subscribe((x) => {
      //console.log(x);
      this.deleteApp(this.dataCntrl.application.id);

      this.router.navigate([
        "/carrier/permit/application/" + this.dataCntrl.carrierID,
      ]);
    });
    //this.dataCntrl.application.id
    //this.dataCntrl.permit.id
  }
  deletePermit(id) {
    this.permitService.deletePermit(id).subscribe((x) => {
      //console.log(x);
    });
  }
  deleteApp(id) {
    this.applicationService.deleteApplication(id).subscribe((x) => {});
  }
  onChange(event) {
    this.getDocSaved(parseInt(event));
  }
  selectedDocType(event) {}

  checkDocType(linkedDocs) {
    let docType = this.doctypesCodes.find(
      (x) => x.id == linkedDocs.document_type_id
    );
    if (docType == null || docType == undefined) return false;
    return docType.is_for_vehicle;
  }
  onVehicleSelectChange(vehicleSelect, docType) {
    this.vehicleId = vehicleSelect.value;
    this.documentType = docType;
    if (vehicleSelect.value == "") {
      this.vehicleId = 0;
      this.documentType = null;
    }
  }
  backToTab() {
    if (this.router.url.indexOf("duplicate") > 0) {
      this.applicationService.setTab(0);
      // this.router.navigate(['/carrier/permit/application/duplicate/' + this.dataCntrl.permit.application_id]);
    } else if (this.replaceVehicle) {
      this.applicationService.setTab(2);
    } else if (
      this.dataCntrl.compID != null ||
      this.dataCntrl.compID != undefined
    ) {
      this.applicationService.setTab(0);
    } else {
      const tabNum = this.utility.tabPosition(
        this.utility.sequenceNumbers.uploadsNum
      );
      this.applicationService.setTab(tabNum);
      if(this.utility.timetableActive){
        document.getElementById('uploads1-stepper-prev').click();
      }else{
        document.getElementById('uploads-stepper-prev').click();
      }
      //if (this.utility.timetableActive) {
      //  this.applicationService.setTab(4);
      //} else {
      //  this.applicationService.setTab(3);
      //}
    }
  }

  checkIfKiosk() {
    this.documentService.checkIfKiosk().subscribe(
      (res: any) => {
  

        this.isKiosk = true;
      },
      (err) => {
    
      }
    );
  }

  scanDocument(id) {
    this.isLoadingImg = true;
    this.scanDocumentId = id;
    this.scanner.getKioskScanner().subscribe(
      (result:string) => {
        if (result) {
   
          this.scanner.getScannerByDeviceID(result.replace(' ', '')).subscribe(
            (response: any) => {
        
              if (response.status_id == 1014) {
                this.isPromptUserToScan = true;
                this.isViewMode = false;
                this.scannerMessage = `Please go and insert your paper to the scanner ${response.scanner_alias} and click the scan button `;
                response.status_id = 1015;
                response.pc_ip_address = result;
                response.status = null;
                this.selectedScanner = response;
                this.scanner.update(response).subscribe((res) => {
              
                });

                document.getElementById("btnView").click();
                this.isLoadingImg = false;
              } else {
                this.toastService.error(
                  `Scanner ${response.scanner_alias} is currently not available, please try again later`,'Error'
                );
              }
            },
            (error) => {
              this.toastService.error(
                "An error occurred when getting the scanner details. Please try again later or contact the administrator",'Error'
              );
            }
          );
        }
       
      },
      (err) => {
        this.toastService.error(
          "An error occured getting the scanner details from the kiosk. Please try again later or contact the administrator"
        ,'Error');
        this.isLoadingImg = false;
      }
    );
  }

  cancelScanner() {
    if(this.selectedScanner){
      this.selectedScanner.status_id = 1014;
      this.scanner.update(this.selectedScanner).subscribe((res) => {

      });
    }

  }

  callTheScanner() {
    this.isLoadingImg = true;
    this.pdfSrc = null;
    this.scannedDocument = null;
    this.selectedScanner.status_id = 1015;
    this.scanner.update(this.selectedScanner).subscribe((res) => {
 
    });

    this.isPromptUserToScan = false;
    this.documentService.scanDocument().subscribe((x) => {

      this.scannedDocument = x;
      let objectURL = URL.createObjectURL(x);

      this.pdfSrc = objectURL;
      this.isLoadingImg = false;
      this.selectedScanner.status_id = 1014;
      this.scanner.update(this.selectedScanner).subscribe((res) => {
     
      });
      //document.getElementById("btnView").click();

      //Post this document to sharepoint.
    }, error =>{
      this.toastService.error(
        "An error occured in scanner, please make sure the paper is properly placed in the scanner and retry to scan again."
      ,'Error');

      this.selectedScanner.status_id = 1014;
      this.scanner.update(this.selectedScanner).subscribe((res) => {
     
        this.isLoadingImg = false;
      });
    });
  }

  postScannedDoc() {

    var reader = new FileReader();
    reader.removeEventListener;
    if(this.scannedDocument){
      reader.readAsDataURL(this.scannedDocument);
      reader.onload = () => {
        this.filebytes = reader.result.toString().split(",")[1];
        this.filesize = this.scannedDocument.size.toString();
        this.filetype = this.scannedDocument.type;
        this.filename =
          "Scan" + this.datepipe.transform(new Date(), "ddMMyyyyHHmmss") + ".pdf";
        this.filedescription = "upload";
        document.getElementById("btnView").click();
        this.isLoadingImg = true;
        this.isLoading = true;
        this.validateData(this.scanDocumentId);
       
      };
    }
   
  }
  onFileChange(event,documenttypeid){
    let file: any = null  
    file = Object.keys(event).map(key => event[key]);
   this.handleDropFileInput(file,documenttypeid);
 
   // this.toastr.info(`File uploaded successfully`, 'File Upload.');
 }
 handleDropFileInput(event, id) {
  const reader = new FileReader();

  if (event && event.length > 0) {
    let file: any = null;
    const count = event.length;
    file = event[count - 1];
    let result = this.checkFileType(file.name);
    // item.document_type_id = this.docTypeData.id;
    // item.code = this.doctypesDesc.code
    // item.description=file.name;
    this.docTypeId = id;
    // this.uploadInfo.push(this.docTypeData);
    // localStorage.setItem('uploads',JSON.stringify(this.uploadInfo));
    const reader = new FileReader();

    if (event && event.length > 0) {
      let file: any = null;
      const count = event.length;

      file = event[count - 1];
      let result = this.checkFileType(file.name);

      //if File type is in not found
      if (result != -1) {
        let sizeresult = this.checkFileSize(file.size);

        if (sizeresult != -1) {
          this.ref.detectChanges();

          reader.removeEventListener;
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.filebytes = reader.result.toString().split(",")[1];
            (this.filename = file.name), (this.filetype = file.type);
            this.filedescription = "upload";
            this.filesize = file.size;
           
            this.validateData(this.docTypeId);
          };
        } else {
          // this.uploader.nativeElement.value = ''
          let allowedFileSize =
            environment.authWebApi.systemData.Configurations.find(
              (p) => p.Code == "MaxUploadMB1"
            );
          // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`, statuscode: '404',url: null, servermessage: "File size exceeded maximum size"});
          this.toastService.error(
            `Maximum file size allowed ${allowedFileSize.Value.toString()}MB`,
            "File Upload Failed, Please try again."
          );
        }
      } else {
        //send message allowed types
        // this.uploader.nativeElement.value = ''
        let allowedFileTypes =
          environment.authWebApi.systemData.Configurations.find(
            (p) => p.Code == "UploadDocTypes1"
          );

        // this.dialogService.addDialog(ErrorComponent, { title: 'File Upload Failed, Please try again.', message: `Only these file types are allowed  ${allowedFileTypes.Value.toString()}`, statuscode: '404',url: null, servermessage: "Extension not allowed"});
        this.toastService.error(
          `Only these file types are allowed: PDF`,
          "File Upload Failed, Please try again."
        );
        //Only these file types are allowed  ${allowedFileTypes.Value.toString()}
      }
    }

    // this.uploader.nativeElement.value = ''
    // this.showOtherUploadsOption = false;
  }
}
handleDuplicate (file :any):boolean
{
  let isUploaded=false;
  this.uploadedDocs.forEach(
    function (value) {
      if (file.name == value.file_name) {
        this.toastService.error(
          `You already uploaded this file`,
          "File upload failed"
        );
        isUploaded= true;
      }
    }.bind(this)
  );
return isUploaded;
}
}
